<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive && isRouterAlive" />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  data () {
    return {
      isRouterAlive: true
    }
  },
  provide () {
    return {
      pageReload: this.pageReload
    }
  },
  created () {
    // 在页面加载时读取sessionStorage里的状态信息
    // if (sessionStorage.getItem('storeData')) {
    //   this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('storeData'))))
    // }
    // // 在页面刷新时将vuex里的信息保存到sessionStorage里
    // window.addEventListener('beforeunload', () => {
    //   sessionStorage.setItem('storeData', JSON.stringify(this.$store.state))
    // })

    this.$store.commit('SET_CLIENT_HEIGHT', document.body.clientHeight)
    this.canIUseCanGoBack()
  },
  destroyed () {
    window.removeEventListener('beforeunload', null)
    sessionStorage.removeItem('storeData')
  },
  methods: {
    ...mapMutations([
      'setCanIUseCanGoBack'
    ]),
    /**
     * @function 判断能否使用CanGoBack
     */
    canIUseCanGoBack () {
      this.$jfs.canIUse({
        bridgeName: 'canGoBack'
      }).then(res => {
        console.log('canIUse canGoBack', res)
        if (res && res.hasBridge) {
          this.setCanIUseCanGoBack(true)
        }
      })
    },
    pageReload () {
      console.log('PAGE RELOAD')
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#app {
  height: 100%;
  // min-height: 100vh;
}
</style>
